// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation ResendTwoFactorCodeMutation($input: ResendTwoFactorCodeInput!) {
    resendTwoFactorCode(input: $input) {
      success
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
